// Styles
import styles from "components/atoms/Status/status.module.css";

type StatusProps = {
	status: string;
};

const Status = ({ status }: StatusProps) => {
	return <span className={styles[status]}>{status.toUpperCase()?.replace("_", " ")}</span>;
};

export default Status;
